import React from 'react';
import { clsx } from 'clsx';

interface TableBodyProps extends React.HTMLAttributes<HTMLTableSectionElement> {
  children: React.ReactNode;
}

export function TableBody({ children, className, ...props }: TableBodyProps) {
  return (
    <tbody 
      className={clsx("bg-white divide-y divide-gray-200", className)} 
      {...props}
    >
      {children}
    </tbody>
  );
} 